export function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value && typeof value === 'object' && !Array.isArray(value))
}

export function isFirebasePermissionDeniedError(error: unknown) {
  if (!isRecord(error) || typeof error.code !== 'string') {
    return false
  }

  return error.code === 'permission-denied' || error.code === 'auth/insufficient-permission'
}

export function getFirebaseAuthErrorCode(error: unknown) {
  if (!isRecord(error) || typeof error.code !== 'string') {
    return null
  }

  return error.code
}
